module.exports = __webpack_public_path__ + "static/media/People.2f6d96a6.svg";